/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { NewMapOptions } from "app/components/map/ui-models/new-map-options";
import { SessionSettings } from "app/models/session-settings";
import { Url_Base } from "app/rest-constants";
import { RestService } from "./rest-service";

@Injectable()
export class ServerSettingsService {

    constructor(
        private restService: RestService
    ) { }

    getMapOptions(): Promise<NewMapOptions> {
        const url = Url_Base + "/server-settings/map-options";
        return this.restService.get<NewMapOptions>(url);
    }

    getSessionSettings(): Promise<SessionSettings> {
        const url = `${Url_Base}/server-settings/session-settings`;
        return this.restService.get<SessionSettings>(url);
    }

}
